import {
  AppData,
  ComponentRemovedHookFunc,
  ComponentRemovedHookParams,
  DocumentServicesObject,
} from '@wix/document-services-types';
import { getComponentId, getAppDefId } from '../../../utils/component';
import {
  getPageDataByComponentId,
  isComponentEssential,
} from '../componentSettings';
import { IExperimentsApiAdapter } from '../../../utils/experimentsApiAdapter';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

let _isCurrentlyUninstalling = false;

const uninstallApp = async (
  platformApiMethods: PlatformApiMethods,
  appData: AppData,
  shouldOpenConfirmationPanel: boolean,
) => {
  if (!_isCurrentlyUninstalling) {
    _isCurrentlyUninstalling = true;
    await platformApiMethods.document.application.uninstall(
      appData as AppData,
      'token',
      {
        openConfirmation: shouldOpenConfirmationPanel,
      },
    );
    _isCurrentlyUninstalling = false;
  }
};

export const componentRemovedHook = (
  platformApiMethods: PlatformApiMethods,
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
): ComponentRemovedHookFunc => {
  return async ({ dataItem }: ComponentRemovedHookParams) => {
    const appDefId = getAppDefId(dataItem);
    const componentId = getComponentId(dataItem);
    if (appDefId) {
      const appData =
        documentServicesAPI.platform.getAppDataByAppDefId(appDefId);

      const pageData = getPageDataByComponentId(appData, componentId);
      const pageId = pageData?.base?.id;

      const shouldReadDataFromNewSchema = experimentsAPI.enabled(
        'specs.editor-platform.unified-components-proto-changes',
      );

      if (
        componentId &&
        appData &&
        isComponentEssential(
          componentId,
          appData,
          shouldReadDataFromNewSchema,
          pageId,
        )
      ) {
        await uninstallApp(platformApiMethods, appData, false);
      }
    }
  };
};
